import { render, staticRenderFns } from "./NotAccepted.vue?vue&type=template&id=6ba6c2e7&scoped=true&"
import script from "./NotAccepted.vue?vue&type=script&lang=ts&"
export * from "./NotAccepted.vue?vue&type=script&lang=ts&"
import style0 from "./NotAccepted.vue?vue&type=style&index=0&id=6ba6c2e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6c2e7",
  null
  
)

export default component.exports